<template>
  <authorization
    permissionKey="attendance_prescription"
    can="save"
    v-slot:default="{ authorization }"
  >
    <v-container fluid v-if="authorization">
      <v-row dense>
        <v-col class="text-h3 gray--text"> Receituário </v-col>

        <v-col cols="auto">
          <v-btn
            outlined
            color="light-blue"
            @click="downloadFile"
            :disabled="!prescription || printLoading"
            :loading="printLoading"
          >
            Imprimir
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            color="gray lighten-1"
            dark
            :to="`/prontuario/${attendance.id}/receituario`"
          >
            voltar
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <EsignButton :esign="prescription.lastEsign" v-if="prescription" />
        </v-col>
      </v-row>

      <v-row dense align="center" justify="space-between">
        <v-col cols="auto">
          <v-combobox
            v-model="template"
            outlined
            dense
            label="Protocolo"
            :items="orderedTemplates"
            item-text="name"
            hide-details
            @change="activeTemplate"
            background-color="white"
            :disabled="signed"
          />
        </v-col>

        <v-col cols="auto">
          <v-switch
            v-model="specialControl"
            label="Controle especial"
            @change="debouncedUpdateSpecialControl"
            :disabled="signed"
          />
        </v-col>

        <v-col cols="auto">
          <v-switch
            v-model="showAttendanceDateOnPrint"
            label="Mostrar data do atendimento"
            @change="debouncedUpdateSpecialControl"
            :disabled="signed"
          />
        </v-col>

        <v-spacer />
      </v-row>

      <v-tabs
        v-model="applicationRouteTab"
        show-arrows
        background-color="transparent"
        color="light-blue"
      >
        <v-tab v-for="tabOption in tabOptions" :key="`tab-${tabOption.id}`">
          {{ tabOption.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="applicationRouteTab"
        :style="{ backgroundColor: 'transparent' }"
      >
        <v-tab-item
          v-for="tabOption in tabOptions"
          :key="`tab-${tabOption.id}`"
          eager
        >
          <v-row v-if="!showForm">
            <v-col cols="auto">
              <v-btn @click="showForm = true" color="light-blue" dark>
                Incluir medicamento
              </v-btn>
            </v-col>
          </v-row>

          <PrescriptionFormGuidance
            v-if="tabOption.id === -1"
            v-show="showForm"
            :attendance="attendance"
            :prescriptionId="prescriptionId"
            :prescriptionInput="prescriptionInput"
            :clearFlag="clearFlag"
            :refreshList="refreshList"
            :guidancePresets="prescriptionGuidancePresets"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            @updatePrescriptionId="updatePrescriptionId"
            :disabled="signed"
            :hideForm="hideForm"
            :addNewItem="addNewItem"
          />

          <!-- <PrescriptionFormExtraMedication -->
          <!--   v-else-if="tabOption.id === -2" -->
          <!--   v-show="showForm" -->
          <!--   :attendance="attendance" -->
          <!--   :prescriptionId="prescriptionId" -->
          <!--   :prescriptionInput="prescriptionInput" -->
          <!--   :clearFlag="clearFlag" -->
          <!--   :refreshList="refreshList" -->
          <!--   :applicationRoutesPresets="medicineApplicationRoutes" -->
          <!--   :prescriptionFrequencies="prescriptionFrequencies" -->
          <!--   :prescriptionPeriods="prescriptionPeriods" -->
          <!--   :prescriptionHowLongs="prescriptionHowLongs" -->
          <!--   @updatePrescriptionId="updatePrescriptionId" -->
          <!--   :hideForm="hideForm" -->
          <!--   :addNewItem="addNewItem" -->
          <!-- /> -->

          <PrescriptionFormItem
            v-else
            v-show="showForm"
            :others="tabOption.name === 'outros usos'"
            :attendance="attendance"
            :prescriptionId="prescriptionId"
            :prescriptionInput="prescriptionInput"
            :clearFlag="clearFlag"
            :refreshList="refreshList"
            :applicationRoute="tabOption"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            @updatePrescriptionId="updatePrescriptionId"
            :disabled="signed"
          />

          <v-row v-if="showForm" justify="space-between">
            <v-col cols="auto" class="gray--text">
              <v-btn v-if="tabOption.id !== -2" @click="hideForm" color="gray lighten-1" dark>minimizar</v-btn> </v-col>
            <v-col cols="auto">
              <v-btn v-if="tabOption.id !== -1 && tabOption.id !== -2" @click="addNewItem" outlined color="light-blue">incluir outro medicamento</v-btn>
              <v-btn v-if="tabOption.id == -1" @click="addNewItem" outlined color="light-blue">incluir outra Orientação</v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>

      <v-divider />

      <v-row
        v-for="(
          prescriptionItems, routeName
        ) in prescriptionItemsperApplicationRoute"
        :key="routeName"
      >
        <v-col>
          <v-row>
            <v-col class="text-h5 text-capitalize">
              {{ routeName }}
            </v-col>
          </v-row>

          <v-row
            dense
            v-for="(prescriptionItem, index) in prescriptionItems"
            :key="prescriptionItem.id"
          >
            <v-col>
              <PrescriptionItem
                :attendance="attendance"
                :prescriptionItem="prescriptionItem"
                :index="index"
                :prescriptionId="prescriptionId"
                :prescriptionInput="prescriptionInput"
                :refreshList="refreshList"
                :medicineApplicationRoutes="medicineApplicationRoutes"
                :prescriptionFrequencies="prescriptionFrequencies"
                :prescriptionPeriods="prescriptionPeriods"
                :prescriptionHowLongs="prescriptionHowLongs"
                :disabled="signed"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="!lodash.isEmpty(prescriptionGuidances)">
        <v-col>
          <v-row>
            <v-col class="text-h5 text-capitalize"> Orientações </v-col>
          </v-row>

          <PrescriptionGuidance
            v-for="(prescriptionGuidance, index) in prescriptionGuidances"
            :key="prescriptionGuidance.id"
            :index="index"
            :prescriptionGuidance="prescriptionGuidance"
            :attendance="attendance"
            :guidancePresets="prescriptionGuidancePresets"
            :prescriptionId="prescriptionId"
            :prescriptionInput="prescriptionInput"
            :refreshList="refreshList"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            :disabled="signed"
          />
        </v-col>
      </v-row>

      <v-row v-if="!lodash.isEmpty(prescriptionNewMeds)">
        <v-col>
          <v-row>
            <v-col class="text-h5 text-capitalize"> Medicações Extras </v-col>
          </v-row>

          <PrescriptionNewMed
            v-for="(prescriptionNewMed, index) in prescriptionNewMeds"
            :key="prescriptionNewMed.id"
            :index="index"
            :prescriptionNewMed="prescriptionNewMed"
            :attendance="attendance"
            :prescriptionId="prescriptionId"
            :prescriptionInput="prescriptionInput"
            :refreshList="refreshList"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            :disabled="signed"
            :hideForm="hideForm"
            :addNewItem="addNewItem"
          />
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
import GET_PRESCRIPTION_FREQUENCIES from "@/graphql/prescription/frequencies.gql";
import GET_PRESCRIPTION_PERIODS from "@/graphql/prescription/periods.gql";
import GET_PRESCRIPTION_HOW_LONGS from "@/graphql/prescription/how_longs.gql";
import GET_PRESCRIPTION_GUIDANCE_PRESETS from "@/graphql/prescription/guidance_presets.gql";
import GET_MEDICINE_APPLICATION_ROUTES from "@/graphql/medicine/medicine_application_routes.gql";
import GET_TEMPLATES from "@/graphql/prescription/templates.gql";
import UPDATE_PRESCRIPTION from "@/graphql/prescription/update_prescription.gql";
import ACTIVE_TEMPLATE from "@/graphql/prescription/active_template.gql";

import PrescriptionFormItem from "@/components/prescription/form/item.vue";
import PrescriptionFormGuidance from "@/components/prescription/form/guidance.vue";
//import PrescriptionFormExtraMedication from "@/components/prescription/form/new_med.vue";
import PrescriptionItem from "@/components/prescription/item.vue";
import PrescriptionGuidance from "@/components/prescription/guidance.vue";
import PrescriptionNewMed from "@/components/prescription/new_med.vue";

import GET_PRESCRIPTION from "@/graphql/prescription/prescription.gql";

export default {
  name: "Prescription",
  props: {
    attendance: Object,
  },
  components: {
    PrescriptionFormItem,
    PrescriptionItem,
    PrescriptionFormGuidance,
    //PrescriptionFormExtraMedication,
    PrescriptionGuidance,
    PrescriptionNewMed,
  },
  data() {
    return {
      prescriptionId: "",
      showForm: true,
      clearFlag: "",
      applicationRouteTab: null,
      prescriptionItem: {},
      prescriptionItemId: null,
      prescriptionItemActionId: "",
      skipSave: false,
      printLoading: false,
      medicineApplicationRoutes: [],
      template: "",
      prescriptionInput: {
        specialControl: false,
        showAttendanceDateOnPrint: false,
      },
    };
  },
  created() {
    if (this.$route.params.prescription_id) {
      if (this.$route.params.prescription_id !== "novo") {
        this.prescriptionId = this.$route.params.prescription_id;
      }
    }

    this.debouncedUpdateSpecialControl = this.lodash.debounce(
      this.updateSpecialControl,
      2000
    );
  },
  apollo: {
    medicineApplicationRoutes: {
      query: GET_MEDICINE_APPLICATION_ROUTES,
      update(data) {
        return this.lodash.orderBy(
          data.medicineApplicationRoutes,
          ["createdAt"],
          ["desc"]
        );
      },
    },
    prescriptionFrequencies: {
      query: GET_PRESCRIPTION_FREQUENCIES,
    },
    prescriptionPeriods: {
      query: GET_PRESCRIPTION_PERIODS,
    },
    prescriptionHowLongs: {
      query: GET_PRESCRIPTION_HOW_LONGS,
    },
    prescriptionGuidancePresets: {
      query: GET_PRESCRIPTION_GUIDANCE_PRESETS,
    },
    prescription: {
      query: GET_PRESCRIPTION,
      variables() {
        return {
          prescriptionId: this.prescriptionId,
        };
      },
      skip() {
        return !this.prescriptionId;
      },
      result({ data }) {
        this.specialControl = data.prescription.specialControl;
        this.showAttendanceDateOnPrint =
          data.prescription.showAttendanceDateOnPrint;
      },
      pollInterval: 20000,
    },
    prescriptionTemplates: {
      query: GET_TEMPLATES,
    },
  },
  computed: {
    tabOptions() {
      let tabOptions = this.lodash.orderBy(this.medicineApplicationRoutes, ['position'], ['asc']);
      if (tabOptions.length > 0) {
        tabOptions.push({ id: -1, name: "Orientações" });
        //tabOptions.push({ id: -2, name: "Medicações Extras" });
      }

    return tabOptions;
    },
    prescriptionItemsperApplicationRoute() {
      return this.lodash.groupBy(
        this.prescriptionItems,
        "applicationRoute.name"
      );
    },
    prescriptionItems() {
      if (this.prescription) {
        return this.lodash.orderBy(
          this.prescription.items,
          ["createdAt"],
          ["desc"]
        );
      }

      return [];
    },
    prescriptionGuidances() {
      if (this.prescription) {
        return this.lodash.orderBy(
          this.prescription.guidances,
          ["createdAt"],
          ["desc"]
        );
      }

      return [];
    },
    prescriptionNewMeds() {
      if (this.prescription) {
        return this.lodash.orderBy(
          this.prescription.newMeds,
          ["createdAt"],
          ["desc"]
        );
      }

      return [];
    },
    orderedTemplates() {
      if (!this.prescriptionTemplates) return;
      return this.lodash.orderBy(
        this.prescriptionTemplates,
        [
          (e) =>
            e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    signed() {
      if (this.prescription) {
        return this.prescription.lastEsign.status !== "editable";
      }

      return false;
    },
    specialControl: {
      get() {
        return this.prescriptionInput.specialControl;
      },
      set(value) {
        this.$set(this.prescriptionInput, "specialControl", value);
      },
    },
    showAttendanceDateOnPrint: {
      get() {
        return this.prescriptionInput.showAttendanceDateOnPrint;
      },
      set(value) {
        this.$set(this.prescriptionInput, "showAttendanceDateOnPrint", value);
      },
    },
  },
  methods: {
    updatePrescriptionId(e) {
      this.prescriptionId = e;
    },
    editPrescriptionItem(prescriptionItem) {
      this.prescriptionItem = prescriptionItem;
    },

    hideForm() {
      this.showForm = false;
    },

    async refreshList() {
      await this.$apollo.queries.prescription.refetch();
    },

    addNewItem() {
      this.clearFlag = Math.random().toString(36).substring(7);
    },

    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.prescription.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true,
        },
      });
    },

    async downloadFile() {
      if (this.prescription) {
        this.printLoading = true;
        await this.refreshList();
        await this.generatePreview();
        await this.refreshList();
        //await this.$store.dispatch("authentication/refreshToken");
        const file_url = this.prescription.lastEsign.fileUrl;
        await window.open(
          `${process.env.VUE_APP_BASE_URL}${file_url}`,
          "_blank"
        );
        this.printLoading = false;
      }
    },

    updateSpecialControl() {
      if (this.signed) return;
      if (!this.prescription) return;

      this.apolloMutate({
        mutation: UPDATE_PRESCRIPTION,
        variables: {
          prescriptionId: this.prescription.id,
          specialControl: this.specialControl,
          showAttendanceDateOnPrint: this.showAttendanceDateOnPrint,
        },
      }).then(() => {
        this.refreshList();
      });
    },

    activeTemplate(template) {
      if (this.signed) return;

      if (!template) return;

      this.template = { name: "" };

      this.apolloMutate({
        mutation: ACTIVE_TEMPLATE,
        variables: {
          attendanceId: this.attendance.id,
          templateId: template.id,
          prescriptionId: this.prescriptionId,
        },
      }).then(({ data }) => {
        this.prescriptionId = data.prescriptionActiveTemplate.id;
        this.refreshList();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
